module.exports = __webpack_public_path__ + "media/images/map/work-6f6f211cab677b1cf24e6e0107020ed3.svg";